import {
  useGetBomUserByCommunityId,
  useGetPropertyOwnerById,
  useGetUserById,
} from "@/services/users";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useApis = () => {
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const id = communityData?.communityId;

  const userData = useSelector(
    (state: RootState) => state.currentData.userData
  );

  // -----------------------------------------------------------
  const {
    data: propertyOwnerDtl,
    isLoading: isPropertyOwnerDetailsLoading,
    isRefetching: isPropertyOwnerDetailsRefetching,
  } = useGetPropertyOwnerById({
    id: userData?.occupancyId,
    queryParams: {
      enabled: !!userData?.occupancyId, // occupancy ID
    },
  });

  const {
    data: userDetails,
    isLoading: isUserDetailsLoading,
    isRefetching: isUserDetailsRefetching,
  } = useGetUserById({
    id: userData?.userId,
    queryParams: {
      enabled: !!userData?.userId,
    },
  });

  const {
    data: bomUserDetails,
    isLoading: isBomUserDetailsLoading,
    isRefetching: isBomUserDetailsRefetching,
  } = useGetBomUserByCommunityId({
    id: userData?.userId,
    communityId: id as string,
    queryParams: {
      enabled: !!userData?.userId,
    },
  });

  return {
    userDetails,
    isUserDetailsLoading,
    isPropertyOwnerDetailsLoading,
    propertyOwnerDtl,
    bomUserDetails,
    isBomUserDetailsLoading,
    isPropertyOwnerDetailsRefetching,
    isBomUserDetailsRefetching,
    isUserDetailsRefetching,
  };
};

export default useApis;
